// src/App.js
import  {useEffect} from 'react';
import AppRouter from './router/index';
import { TranslationProvider } from './contexts/TranslationContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/css/style.bundle.css';
import './assets/css/brand-ui.css';

function App() {
  useEffect(() => {
        

  }, []);
  
  return (
    <TranslationProvider>
      <div>
        <AppRouter />
        <ToastContainer />
      </div>
    </TranslationProvider>
  );
}

export default App;
